import { render, staticRenderFns } from "./hdcgthtsx.vue?vue&type=template&id=890b6130&scoped=true&"
import script from "./hdcgthtsx.vue?vue&type=script&lang=js&"
export * from "./hdcgthtsx.vue?vue&type=script&lang=js&"
import style0 from "./hdcgthtsx.vue?vue&type=style&index=0&id=890b6130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890b6130",
  null
  
)

export default component.exports